import { memo } from 'react';

import { isWebPlatform } from '../../../boot/utils';
import HeaderSearchBar from './HeaderSearchBar';

const ListHeader = () => {
  return <>{isWebPlatform && <HeaderSearchBar />}</>;
};

export default memo(ListHeader);
